import { Channel } from '@/Enums/Channel.enum';
import Color from '@/Enums/Color.enum';
import { PacingApiStatus } from '@/Enums/Pacing/PacingApiStatus.enum';
import { PacingStatus } from '@/Enums/Pacing/PacingStatus.enum';
import { IControlOption } from '@/Interfaces/ControlOption.interface';
import { IGridTotal } from '@/Interfaces/Pacing/GridTotal.interface';
import { PacingLineItemChannel } from '@/types/Pacing/channel.types';

// TODO: replace w/ src/Enums/Pacing/ViewLevel.enum.ts
export const LEVEL_VALUES = {
  CAMPAIGN: 'Campaign',
  LINE_ITEM: 'Line Item',
  FLIGHT: 'Flight',
  FULL_VIEW: 'Full View',
};

export const LEVEL_LABELS = {
  [LEVEL_VALUES.CAMPAIGN]: 'Campaign',
  [LEVEL_VALUES.LINE_ITEM]: 'Line Item',
  [LEVEL_VALUES.FLIGHT]: 'Flight',
  [LEVEL_VALUES.FULL_VIEW]: 'Full View',
};

export const LEVEL_OPTIONS = [
  { label: LEVEL_LABELS[LEVEL_VALUES.CAMPAIGN], value: LEVEL_VALUES.CAMPAIGN },
  { label: LEVEL_LABELS[LEVEL_VALUES.LINE_ITEM], value: LEVEL_VALUES.LINE_ITEM },
  { label: LEVEL_LABELS[LEVEL_VALUES.FLIGHT], value: LEVEL_VALUES.FLIGHT },
  { label: LEVEL_LABELS[LEVEL_VALUES.FULL_VIEW], value: LEVEL_VALUES.FULL_VIEW },
];

// TODO: replace w/ src/Enums/Pacing/PacingStatus.enum.ts
export const PACING_STATUS_VALUES = {
  UNDER_PACING: 'Under Pacing',
  RISK_PACING: 'Risk Pacing',
  ON_TARGET: 'On Target',
  OVER_PACING: 'Over Pacing',
};

export const PACING_STATUS_LABELS = {
  [PACING_STATUS_VALUES.UNDER_PACING]: 'Under Pacing',
  [PACING_STATUS_VALUES.RISK_PACING]: 'Risk Pacing',
  [PACING_STATUS_VALUES.ON_TARGET]: 'On Target',
  [PACING_STATUS_VALUES.OVER_PACING]: 'Over Pacing',
};

export const PACING_STATUS_OPTIONS = [
  { label: PACING_STATUS_LABELS[PACING_STATUS_VALUES.UNDER_PACING], value: PacingStatus.UnderPacing },
  { label: PACING_STATUS_LABELS[PACING_STATUS_VALUES.RISK_PACING], value: PacingStatus.RiskPacing },
  { label: PACING_STATUS_LABELS[PACING_STATUS_VALUES.ON_TARGET], value: PacingStatus.OnTarget },
  { label: PACING_STATUS_LABELS[PACING_STATUS_VALUES.OVER_PACING], value: PacingStatus.OverPacing },
];

export const STATUS_LABELS = {
  [PacingApiStatus.ACTIVE]: 'Active',
  [PacingApiStatus.INACTIVE]: 'Inactive',
};

export const STATUS_OPTIONS = [
  { label: STATUS_LABELS[PacingApiStatus.ACTIVE], value: PacingApiStatus.ACTIVE },
  { label: STATUS_LABELS[PacingApiStatus.INACTIVE], value: PacingApiStatus.INACTIVE },
];

export const PACING_STATUS_COLORS = {
  [PACING_STATUS_VALUES.UNDER_PACING]: Color.AccentRed,
  [PACING_STATUS_VALUES.RISK_PACING]: Color.AccentYellow,
  [PACING_STATUS_VALUES.ON_TARGET]: Color.LightGreen2,
  [PACING_STATUS_VALUES.OVER_PACING]: Color.Purple,
};

export const DEFAULT_PACING_STATUS_COUNT = {
  [PACING_STATUS_VALUES.UNDER_PACING]: 0,
  [PACING_STATUS_VALUES.RISK_PACING]: 0,
  [PACING_STATUS_VALUES.ON_TARGET]: 0,
  [PACING_STATUS_VALUES.OVER_PACING]: 0,
};

export const BASE_TAB_ID = 'pacing-filter-tab';

export const CHANNEL_OPTIONS: IControlOption<string, PacingLineItemChannel>[] = [
  { label: Channel.CTV, value: Channel.CTV },
  { label: Channel.OLV, value: Channel.OLV },
  { label: Channel.Display, value: Channel.Display },
  { label: Channel.Google, value: Channel.Google },
];

export const GRAPH_CONTAINER_ID = 'pacing-graph-container';

export const TOTAL_ROW_ID = 'totals';

export const DEFAULT_TOTAL: IGridTotal = {
  id: TOTAL_ROW_ID,
  booked: 0,
  delivered: 0,
  deliveredToday: 0,
  deliveredYesterday: 0,
  pacingTo: 0,
  remaining: 0,
};
